import { useTranslation } from "react-i18next";
import styles from "./FormulationCard.module.css";

export default function FormulationCard({ formulation, onClick }) {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language.startsWith("ar");

  return (
    <div className={styles.card} onClick={onClick} dir={isRtl ? "rtl" : "ltr"}>
      <div className={styles.imageWrap}>
        {formulation.image ? (
          <img
            src={formulation.image}
            alt={formulation.name}
            className={styles.image}
          />
        ) : (
          <div className={styles.placeholder}>
            <svg
              width="36"
              height="36"
              viewBox="0 0 24 24"
              fill="none"
              stroke="rgba(12,104,57,0.3)"
              strokeWidth="1.2"
            >
              <path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18" />
            </svg>
          </div>
        )}
        {formulation.type && (
          <span
            className={`${styles.typeBadge} ${isRtl ? styles.typeBadgeRtl : ""}`}
          >
            {formulation.type.name}
          </span>
        )}
      </div>

      <div
        className={styles.body}
        style={{ textAlign: isRtl ? "right" : "left" }}
      >
        <h3 className={styles.name}>{formulation.name}</h3>
        {formulation.description && (
          <p className={styles.description}>{formulation.description}</p>
        )}

        {formulation.categories?.length > 0 && (
          <div className={styles.categories}>
            {formulation.categories.slice(0, 3).map((cat) => (
              <span key={cat.id} className={styles.catChip}>
                {cat.name}
              </span>
            ))}
            {formulation.categories.length > 3 && (
              <span className={styles.catChip}>
                +{formulation.categories.length - 3}
              </span>
            )}
          </div>
        )}

        <button className={styles.viewBtn}>
          {t("formulations.viewDetails")}
        </button>
      </div>
    </div>
  );
}
